import { ScenarioBasePath } from '@hooks/scenarios-simulator/types';
import { createContext, useContext, ReactNode } from 'react';

interface ScenarioPathContextType {
  scenarioBasePath: ScenarioBasePath;
}

const ScenarioPathContext = createContext<ScenarioPathContextType>({
  scenarioBasePath: 'inputs.parsedPayload.baseScenario',
});

export function ScenarioPathProvider({
  children,
  scenarioBasePath,
}: {
  children: ReactNode;
  scenarioBasePath: ScenarioBasePath;
}) {
  return <ScenarioPathContext.Provider value={{ scenarioBasePath }}>{children}</ScenarioPathContext.Provider>;
}

export function useScenarioPath() {
  return useContext(ScenarioPathContext);
}
